import React, { useState } from 'react';
import './Footer.css';
import useRevealOnScroll from '../utils/useRevealOnScroll';
import emailjs from '@emailjs/browser';
import { FaPaperPlane, FaTimes } from 'react-icons/fa';

// Social media links data
const socialLinks = [
  { name: 'Instagram', url: 'https://www.instagram.com/menu_bazzar_?igsh=MXplYWh0dWJtdW5u', icon: 'fab fa-instagram' },
  { name: 'Facebook', url: 'https://www.facebook.com/share/1BzE5q6vZ4/', icon: 'fab fa-facebook-f' },
];

const FeedbackForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    try {
      const serviceId = 'service_ezkfokh';
      const templateId = 'template_3u645vj';
      const publicKey = 'f2-6Wb2auHnzX3_Ps';
      
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
        to_email: 'menubazzar@gmail.com',
        reply_to: formData.email
      };
      
      console.log('Sending email with data:', templateParams);

      const response = await emailjs.send(
        serviceId,
        templateId,
        templateParams,
        publicKey
      );

      console.log('Email sent successfully:', response);
      setStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setStatus(''), 3000);
    } catch (error) {
      console.error('Detailed EmailJS error:', {
        name: error.name,
        message: error.message,
        status: error.status,
        text: error.text,
        response: error.response
      });
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="feedback-form-container">
      <button className="close-feedback" onClick={onClose} aria-label="Close feedback form">
        <FaTimes />
      </button>
      <h3>Send Us Your Feedback</h3>
      <form onSubmit={handleSubmit} className="feedback-form">
        <div className="form-group">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            required
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            required
          />
        </div>
        <div className="form-group">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your feedback or message"
            rows="4"
            required
          ></textarea>
        </div>
        <button type="submit" disabled={isSubmitting} className="submit-btn">
          {isSubmitting ? 'Sending...' : (
            <>
              <FaPaperPlane /> Send Message
            </>
          )}
        </button>
        {status === 'success' && (
          <div className="status-message success">
            Thank you for your feedback! We'll get back to you soon.
          </div>
        )}
        {status === 'error' && (
          <div className="status-message error">
            Something went wrong. Please try again later.
          </div>
        )}
      </form>
    </div>
  );
};

export default function Footer() {
  const { ref, isVisible } = useRevealOnScroll({ rootMargin: '0px 0px -4% 0px' });
  const [showFeedback, setShowFeedback] = useState(false);

  return (
    <>
      <footer className={isVisible ? 'footer reveal isVisible' : 'footer reveal'} ref={ref}>
        <div className="container footerInner">
          <div className="footerBrandBlock">
            <div className="footerBrandRow">
              <img
                className="footerLogo"
                src="/logo.png"
                alt="Logo"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>
            <div className="footerText">
              Digital menus, discovery, and a modern browsing experience for restaurants and customers.
            </div>
          </div>

          <div className="footerLinks" aria-label="Footer links">
            <a href="#top">Home</a>
            <a href="#services">Services</a>
            <a href="#city">City</a>
            <a href="#choose">Choose</a>
            <button 
              onClick={() => setShowFeedback(true)}
              className="feedback-link"
              aria-label="Provide feedback"
            >
              Feedback
            </button>
          </div>

          <div className="footerMeta">
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a 
                  key={index} 
                  href={social.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  className="social-link"
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
            <div className="footerCopy">© {new Date().getFullYear()} Menu Bazaar. All rights reserved.</div>
          </div>
        </div>
      </footer>
      
      {showFeedback && (
        <div className="feedback-modal">
          <div className="feedback-modal-content">
            <FeedbackForm onClose={() => setShowFeedback(false)} />
          </div>
        </div>
      )}
    </>
  );
}
